import { apiRequest } from ".";

export const loginAPI = (data) => {
  return apiRequest({
    method: "post",
    url: `user/auth/login`,
    data: data,
  });
};
export const logoutAPI = () => {
  return apiRequest({
    method: "post",
    url: `auth/logout`,
    data: {},
  });
};
export const forgotPwdAPI = (data) => {
  return apiRequest({
    method: "post",
    url: `auth/forgot-password`,
    data: data,
  });
};
export const verifyResetPwdAPI = (data) => {
  return apiRequest({
    method: "get",
    url: `auth/verify-reset-password-code`,
    queryParams: data,
  });
};

export const newPwdAPI = (data) => {
  return apiRequest({
    method: "post",
    url: `auth/change-password`,
    data: data,
  });
};
